import React, { Component } from 'react';
import type { ComponentType } from 'react';
import { Subscribe } from 'unstated';

import { DialogsStateContainer } from './DialogsStateContainer';

export type WithDialogsProps = {
	dialogs: DialogsStateContainer;
};

type PropsWithoutDialog<TProps> =
	Omit<TProps, 'dialogs'> extends never ? {} : Omit<TProps, 'dialogs'>;

export function withDialogs<TProps>(
	InnerComponent: ComponentType<TProps & WithDialogsProps>,
): ComponentType<PropsWithoutDialog<TProps>> {
	return class WithDialogs extends Component<PropsWithoutDialog<TProps>> {
		static displayName = `withDialogs(${InnerComponent.displayName || InnerComponent.name})`;

		render() {
			return (
				<Subscribe to={[DialogsStateContainer]}>
					{(dialogs: DialogsStateContainer) => (
						<InnerComponent {...(this.props as any)} dialogs={dialogs} />
					)}
				</Subscribe>
			);
		}
	};
}
